import { render, staticRenderFns } from "./BlockInternetPolicy.vue?vue&type=template&id=a359cb0e&scoped=true&"
import script from "./BlockInternetPolicy.vue?vue&type=script&lang=ts&"
export * from "./BlockInternetPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./BlockInternetPolicy.vue?vue&type=style&index=0&id=a359cb0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a359cb0e",
  null
  
)

export default component.exports